import {
  ComponentRef,
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnInit,
} from '@angular/core';
import {
  ConnectedPosition,
  Overlay,
  OverlayPositionBuilder,
  OverlayRef,
} from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { TooltipComponent } from './tooltip.component';

@Directive({ selector: '[infoTooltip]' })
export class TooltipDirective implements OnInit {
  @Input('infoTooltip') text = '';
  @Input('infoTooltipPosition') position;
  @Input('infoTooltipWidth') width;
  @Input('infoTooltipFontSize') fontSize;
  @Input('infoTooltipDisabledPositions') disabledPositions = [];
  private overlayRef: OverlayRef;
  constructor(
    private overlay: Overlay,
    private overlayPositionBuilder: OverlayPositionBuilder,
    private elementRef: ElementRef
  ) {}

  ngOnInit(): void {
    const positionStrategy = this.overlayPositionBuilder
      .flexibleConnectedTo(this.elementRef)
      .withPositions(this.setTooltipPosition());
    this.overlayRef = this.overlay.create({ positionStrategy });
  }

  @HostListener('mouseenter')
  show() {
    const tooltipRef: ComponentRef<TooltipComponent> = this.overlayRef.attach(
      new ComponentPortal(TooltipComponent)
    );
    tooltipRef.instance.text = this.text;
    tooltipRef.instance.width = this.width;
    tooltipRef.instance.fontSize = this.fontSize;
  }

  @HostListener('mouseout')
  hide() {
    this.overlayRef.detach();
  }

  setTooltipPosition(): ConnectedPosition[] {
    let possiblePositions: { [key: string]: ConnectedPosition } = {
      top: {
        originX: 'center',
        originY: 'center',
        overlayX: 'center',
        overlayY: 'bottom',
        offsetY: -20,
      },
      bottom: {
        originX: 'center',
        originY: 'center',
        overlayX: 'center',
        overlayY: 'top',
        offsetY: 20,
      },
      left: {
        originX: 'center',
        originY: 'center',
        overlayX: 'end',
        overlayY: 'center',
        offsetX: -20,
      },
      right: {
        originX: 'center',
        originY: 'center',
        overlayX: 'start',
        overlayY: 'center',
        offsetX: 20,
      },
    };
    let positions: ConnectedPosition[] = [];
    for (let prop of Object.keys(possiblePositions)) {
      if (
        this.disabledPositions === undefined ||
        this.disabledPositions.length === 0 ||
        !this.disabledPositions.find((position) => position === prop)
      ) {
        positions.push(possiblePositions[prop]);
      }
    }

    switch (this.position) {
      case 'top': {
        return positions;
      }
      case 'bottom': {
        return this.changePreferredPosition(positions, 1);
      }
      case 'left': {
        return this.changePreferredPosition(positions, 2);
      }
      case 'right': {
        return this.changePreferredPosition(positions, 3);
      }
      default:
        return positions;
    }
  }

  changePreferredPosition(
    positions: ConnectedPosition[],
    idx: number
  ): ConnectedPosition[] {
    const b = positions[idx];
    positions[idx] = positions[0];
    positions[0] = b;
    return positions;
  }
}
